import { AnalyticEvent } from '@wetransfer/transfer/modules/analytics/AnalyticsTypes';
import {
  getAmplitudeSubscriptionPeriod,
  getTierForTracking,
} from '@wetransfer/transfer/modules/analytics/tracking';

const PAGE_CATEGORY = 'pricing_page';

enum BillingCycleValues {
  MONTHLY = 1,
  YEARLY = 12,
}

type AnalyticsTier = 'free' | 'pro' | 'premium';

interface TrackingElements<T> {
  TierButtons: (
    pageCategory: string,
    tier: AnalyticsTier,
    label: 'card' | 'sticky_header',
    property: string,
    value: BillingCycleValues
  ) => T;
  TermSelector: (value: BillingCycleValues) => T;
  FAQ: (label: string) => T;
  ClosePanel: (property: string) => T;
  AmplitudeTracking: (
    pageAction: string,
    tier: string,
    billingPeriod: string
  ) => T;
}

const TrackingConfiguration: TrackingElements<AnalyticEvent> = {
  TierButtons: (pageCategory, tier, label, property, value) => ({
    category: pageCategory,
    action: `click_${tier}_button`,
    label,
    property,
    value,
  }),
  TermSelector: (value) => ({
    category: PAGE_CATEGORY,
    action: 'plan_click',
    value,
  }),
  FAQ: (label) => ({
    category: PAGE_CATEGORY,
    action: 'click_FAQ',
    label,
  }),
  ClosePanel: (property) => ({
    category: PAGE_CATEGORY,
    action: 'click_close_panel',
    property,
  }),
  AmplitudeTracking: (pageAction, tier, billingPeriod) => ({
    action: 'Subscription Funnel',
    additionalProperties: {
      Step: 'Pricing Page',
      Action: pageAction,
      'Subscription Tier': getTierForTracking(tier),
      'Billing Period': getAmplitudeSubscriptionPeriod(billingPeriod),
    },
  }),
};

export default TrackingConfiguration;
